<div class="col-sm-2 parking-passes-filter">
    <div class="parking-passes-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="parking-passes-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="currentCheckbox" #currentCheckbox (change)="changeFilter()">
                <label for="currentCheckbox"><svg-checked></svg-checked></label>
                <span>Current</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="futureCheckbox" #futureCheckbox (change)="changeFilter()">
                <label for="futureCheckbox"><svg-checked></svg-checked></label>
                <span>Future</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="pastCheckbox" #pastCheckbox (change)="changeFilter()">
                <label for="pastCheckbox"><svg-checked></svg-checked></label>
                <span>Past</span>
            </label>
        </div>

        <hr>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="pendingCheckbox" #pendingCheckbox (change)="changeFilter()">
                <label for="pendingCheckbox"><svg-checked></svg-checked></label>
                <span>Pending</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="declinedCheckbox" #declinedCheckbox (change)="changeFilter()">
                <label for="declinedCheckbox"><svg-checked></svg-checked></label>
                <span>Declined</span>
            </label>
        </div>

        <hr>

        <div class="m-b-xs filter-checkbox directory-add-modal-date-field">
            <label>Start Date</label>
            <mat-form-field (click)="startPicker.open()">
                <input matInput [(ngModel)]="startDate" name="startDate" [matDatepicker]="startPicker" disabled
                       (focus)="startPicker.open()" (click)="startPicker.open()"
                       (ngModelChange)="onStartDateChange()" placeholder="Choose a date">
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker disabled="false"></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="m-b-xs filter-checkbox directory-add-modal-date-field">
            <label>End Date</label>
            <mat-form-field (click)="endPicker.open()">
                <input matInput [(ngModel)]="endDate" name="endDate" disabled
                       [matDatepicker]="endPicker" [min]="startDate"
                       (focus)="endPicker.open()" (click)="endPicker.open()" placeholder="Choose a date">
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker disabled="false"></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="row text-center buttons-row">
            <button class="btn btn-primary" [disabled]="!startDate && !endDate" (click)="changeFilter()">
                Apply
            </button>

            <button class="btn btn-primary" *ngIf="startDate || endDate" (click)="clearDates()">
                Clear
            </button>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/parking-passes-filter/parking-passes-filter.component.html